
export default {
    setPoolsInfo(state, payload){
        let pools = payload.pools
        for (const pool of pools) {
            state.pools[pool.pool_id] = pool
            // if (!(Object.keys(state.pools).includes(pool.pool_id))){
            //     state.pools[pool.pool_id] = pool
            // }
        }
        console.info("[setPoolsInfo][Updating pools to store]")
    },
    setPoolDevices(state, payload){
        let pool_devices = payload.devices
        for (const device of pool_devices) {
            state.pool_devices[device.device_id] = device
        }
        console.info("[setPoolsInfo][Updating pool_devicess to store]")
    }
};